import { connect } from 'react-redux'
import Select from 'react-select'
import at from 'lodash/at'
import isEmpty from 'lodash/isEmpty'
import { loadWorkOrdersForLocation } from '../../actions/work-orders'
import { loadLocations, fetchLocation, searchLocations } from '../../actions/locations'
import { fetchTechniciansForLocation } from '../../actions/technicians'
import { loadAreasByLocation } from '../../actions/areas'
import { fetchServicesForLocation } from '../../actions/services'
import { setFiltersLoading, setCalendarFiltersForLocation } from '../../actions/calendar-filters'

const mapStateToProps = (state) => {
  const locations = at(state.locations, state.pagination.locations.ids || [])

  const options = locations.map((location) => (
    {
      value: location.id,
      label: location.name,
    }
  ))

  const { isLoading = false } = state.calendarFilters

  return {
    options,
    isLoading
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onMenuScrollToBottom() {
      dispatch(loadLocations(true))
    },

    // onInputChange (event) {
    //   if (event.length < 1) return
    //   dispatch(searchLocations(event))
    // },

    onChange(item) {
      const locationId = item ? item.value : null
      // console.log(item)
      // console.log(isEmpty(item))
      // if (isEmpty(item)) {
      //   dispatch(searchLocations(''))
      // }
      dispatch(setFiltersLoading(true))
        .then(() => dispatch(setCalendarFiltersForLocation(locationId)))
        .then(() => { if (locationId) dispatch(loadAreasByLocation(locationId)) })
        .then(() => { if (locationId) dispatch(fetchServicesForLocation(locationId)) })
        .then(() => { if (locationId) dispatch(fetchTechniciansForLocation(locationId)) })
        .then(() => ownProps.onChange(item))
        .then(() => dispatch(setFiltersLoading(false)))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Select)



// WEBPACK FOOTER //
// ./src/containers/calendar/select-location-container.js